import React from 'react';

function About() {
  return (
    <section className="about-section" id="about">
      <div className="section-title">
        <h2>About Our College</h2>
      </div>
      <div className="about-content">
        <div className="about-image">
          <img src="/college-photo.jpeg" alt="Jaat College of Education Building" />
        </div>
        <div className="about-text">
          <h3>Nurturing Excellence in Education</h3>
          <p>
            Jaat College of Education came into existence in 2007. The college is working under the 
            administration of Mahavir Shiksha Samiti, Karnal. The college is affiliated by Kurukshetra 
            University and approved by National Council for Teacher Education (NCTE).
          </p>
          <p>
            The college has a magnificent and spacious building with adequate classrooms, 
            well-equipped music room, well-furnished staff room, separate common rooms for boys 
            and girls, and modern communication facilities including PA system, Telephone, Fax, 
            E-mail and Internet.
          </p>
          <div className="about-highlights">
            <div className="highlight-item">
              <div className="highlight-icon">🎓</div>
              <span>B.Ed Program</span>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">🏛️</div>
              <span>NCTE Approved</span>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">📚</div>
              <span>KU Affiliated</span>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon">🏆</div>
              <span>Since 2007</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
